export const COHORT_KEY = 'cohort';
export enum Cohorts {
	ENROLLED = 'enrolled',
	NOT_ENROLLED = 'not-enrolled',
	CONTROL = 'control',
	EXPERIMENT = 'experiment',
	EXPERIMENT_VARIATION_1 = 'experiment-1',
	EXPERIMENT_VARIATION_2 = 'experiment-2',
}
